/**
 * @desc 渠道运费预估
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<number>;
export function request(
  params: API.tms.logisticsPriceFacadeImpl.calculateWaybillPrice.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsPrice/calculateWaybillPrice`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
